<template>
    <w-flex wrap class="text-center basis-zero">


        <div class="xs7 pt2">
            <w-card content-class="pa1" title="Exploded Views" title-class="primary-dark1--bg">

                <w-flex row wrap class="pa0 text-center  ">

                    <w-select class="xs8 pa0" v-model="Files.selection" :items="Files.items" outline return-object>Select An
                        Exploded
                        View</w-select>
                    <w-input class="xs3 pa1" inner-icon-left="wi-search" label-position="inside" outline="outline"
                        label="Pos No " v-model="PosLookup" />
                    <div class="xs1 pa0">
                        <button @click="pdfFile.rotate += 90">&#x27F3;</button>
                        <button @click="pdfFile.rotate -= 90">&#x27F2;</button>
                        <w-button icon="mdi mdi-image" text lg class="ml3 pa1" bg-color=" warning" outline
                            @click="openfile(Files.selection)"></w-button>
                        <!-- </div>
                    <div class="xs1 pa0"> -->
                        <button @click="$refs.zoomer.zoomIn()">+</button>
                        <button @click="$refs.zoomer.zoomOut()">-</button>
                    </div>
                    Pages: {{ pdfFile.currentPage }}
                </w-flex>
                <v-zoomer ref="zoomer" class="bigImg" :mouseWheelToZoom="false" :aspect-ratio="imageAspectRatio"
                    :max-scale="10" :zooming-elastic="false" :zoomed.sync="zoomed">
                    <div class="exploded">

                        <img class="bigImg" v-if="imageFile.src != ''" :src="imageFile.src">
                        <div v-if="pdfFile.progress > 0 && pdfFile.progress < 1"
                            style="background-color: green; color: white; text-align: center"
                            :style="{ width: pdfFile.progress * 100 + '%' }">{{ Math.floor(pdfFile.progress * 100) }}%
                        </div>
                        <pdf v-if="pdfFile.src != ''" v-for="i in numOfPages" :key="i" :page="i" :src="pdfFile.src"
                            :rotate="pdfFile.rotate" @progress="pdfFile.progress = $event"
                            @page-loaded="pdfFile.currentPage = $event"></pdf>

                    </div>
                </v-zoomer>
            </w-card>
        </div>




        <div class=" xs6 pa2">
            <w-card content-class="pa0" :title="'Results    ' + lookingAtModel + ' ' + lookingAtVariant"
                title-class="primary-dark1--bg">
                <w-accordion content-class="pa1" :items="1" v-model="PartsTable.accordion">
                    <template #item-title>Parts {{ PartsTable.items.length }}</template>

                    <template #item-content>
                        <w-flex justify-center class="pa2">
                            <w-input inner-icon-left="wi-search" label-position="inside" outline="outline"
                                label="Part Search " v-model="PartSearch" />
                            <!-- <w-input inner-icon-left="wi-search" label-position="inside" outline="outline"
                                label="Pos No " v-model="PosLookup" /> -->
                            <w-button icon="mdi mdi-filter" text lg class="ml3" bg-color="warning" outline
                                @click="FilterButton()"></w-button>
                        </w-flex>
                        <w-table ref="table" v-on:scroll.passive="handleScroll($event)" :headers="PartsTable.headers"
                            :items="PartsTable.items" :mobile-breakpoint="600" :loading="PartsTable.loading"
                            v-model:sort="PartsTable.sort" :filter="PartsTable.filter"
                            :selectable-rows="PartsTable.selectableRows" @row-select="getPartDetails($event.item)">
                            <template #no-data>👌 There is no data! 👌</template>
                            <template #item="{ item, index, select, classes }">
                                <tr @click="select">
                                    <td v-for="(header, i) in PartsTable.headers" :key="i" :style="item.style">
                                        <img v-if="header.label == 'ID'" :src="item.imageThumbnail"
                                            style=" padding: 3px 3px 0px 3px;" />
                                        {{ item[header.key] || '' }}
                                        <div
                                            v-if="header.label == 'Add To Cart' && item.alternative != undefined ? item.alternative.startsWith('C') : false">
                                            <SvgIcon name="Cart" @click="addPartToShoppingCart(item)">
                                            </SvgIcon>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <!-- <template #item-cell="{ item, label, header }">
                                <div v-if="header.label == 'ID'">
                                    <img :src="item.imageThumbnail" />
                                </div>

                                <div v-if="header.label == 'Add To Cart'">
                                    <SvgIcon name="Cart" @click="addPartToShoppingCart(item)"></SvgIcon>
                                </div>

                                <div :style="item.style">{{ label }}</div>
                            </template> -->
                        </w-table>
                    </template>
                </w-accordion>


                <!-- <w-button bg-color="warning" @click="getALLParts(selectionInfo.selectedRows)">Search Selected</w-button> -->
            </w-card>
        </div>
        <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width"
            :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white">
            <template #title>
                <w-icon class="mr2">mdi mdi-tune</w-icon>View File
            </template>
            <v-zoomer ref="zoomer" class="bigImg" :mouseWheelToZoom="false" :aspect-ratio="imageAspectRatio" :max-scale="10"
                :zooming-elastic="false" :zoomed.sync="zoomed">
                <div style=" overflow-y: scroll; height: 90vh;">

                    <img class="bigImg" v-if="imageFile.src != ''" :src="imageFile.src">

                    <pdf v-if="pdfFile.src != ''" v-for="i in numOfPages" :key="i" :page="i" :src="pdfFile.src"
                        :rotate="pdfFile.rotate"></pdf>
                </div>
            </v-zoomer>
            <template #actions>
                <!-- <button @click="pdfFile.rotate += 90">&#x27F3;</button>
                <button @click="pdfFile.rotate -= 90">&#x27F2;</button> -->
                <button @click="$refs.zoomer.zoomIn()">+</button>
                <button @click="$refs.zoomer.zoomOut()">-</button>
                <div class="spacer"></div>
                <w-button bg-color="warning" @click="dialog.show = false">Close</w-button>
            </template>
        </w-dialog>
    </w-flex>
</template>
  
<script>
import { ref, watch, shallowRef } from "vue";

import pdf from '@jbtje/vue3pdf'

// import json from "../assets/allparts.json";
// import djson from "../assets/allDParts.json";
import router from "../router"
import { usePartStore } from '../store/part'
import { getAltParts, providersToModelList, providersToPartsList, getPartsListFromSupplier, getAswoFileFromUrl } from "../components/Wrapper";
import { createLoadingTask } from 'vue3-pdfjs/esm';
import { useSearchStore } from "../store/search";
import SvgIcon from '../components/SvgIcon.vue';
import { useCartStore } from "../store/cart";
import { tableHeightChanges } from '../components/tableHeightChanges'
import VueZoomer from 'vue-zoomer/src'
export default {
    name: "ModelView",
    components: {
        pdf, SvgIcon,
        VZoomer: VueZoomer.Zoomer,
    }, activated() {

        const searchState = useSearchStore().getSearch()

        if (searchState !== this.partsToGet) {
            this.Files.items = []
            this.Files.selection = {}
            this.fileurl = ""
            this.pdfFile.src = ""
            this.pdfFile.numPages = 0
            this.pdfFile.currentPage = 0
            this.imageFile.src = ""
            this.PosLookup = ""
            this.PartSearch = ""
            this.getALLParts(searchState)
            this.lookingAtModel = searchState[0].model
            this.lookingAtVariant = searchState[0].variant
            // console.log(this.lookingAt)
            // this.openFirstFile(this.Files.selection)
            this.partsToGet = searchState

        }


    },

    mounted() {

        this.partsToGet = useSearchStore().getSearch()
        this.lookingAtModel = this.partsToGet[0].model
        this.lookingAtVariant = this.partsToGet[0].variant
        this.tableInnerHeight = this.$refs.table.$el
        this.tableOuterHeight = this.$refs.table.$el.firstChild
        // console.log('tableInnerHeight', this.tableInnerHeight);
        // console.log('tableOuterHeight', this.$refs.table);

    },

    setup() {
        const lookingAtModel = ref()
        const lookingAtVariant = ref()
        let tableInnerHeight = ref()
        let tableOuterHeight = ref()
        let lastItemOnPage = 10
        const table = ref()
        // const heightChange = tableHeightChanges()
        const dialog = ref({
            show: false,
            fullscreen: true,
            persistent: false,
            persistentNoAnimation: false,
            width: 800,
            height: 800
        });
        const ASWOProvider = { code: "1100757010", name: "ASWO" }; //ASWO
        const ConnectProvider = { code: "1100001235", name: "Connect" }; //Connect

        const Providers = [ASWOProvider, ConnectProvider]
        const newPartSearch = ref("");
        const newSearch = ref("");
        const SparePartSearch = ref("");
        const PartSearch = ref("");
        const StockCheck = ref("In Stock");
        const DeliveryTime = ref(100);
        const Obsolete = ref(-1);
        const PosLookup = ref("");
        const ArticleSearch = ref("");
        const DeviceArticleSearch = ref("");
        const DeviceFilesSearch = ref("");
        const fileurl = ref("");
        const files = ref({});
        const imageFile = ref({
            src: '',
        })
        const pdfFile = ref({
            src: '',
            loadedRatio: 0,
            page: 1,
            currentPage: 0,
            numPages: 0,
            rotate: 0,
            progress: 0,
            zoom: 0
        })
        const Files = ref({
            items: [{ label: "None" }],
            selection: {}
        });
        watch(Files.value, (newValue, oldValue) => {
            openFirstFile(newValue.selection)

            // console.log("Selection Changed", newValue.selection);
        })

        watch(PosLookup, async (newValue, oldValue) => {
            if (newValue.length == 1 && oldValue == "" || newValue.length == 2 && oldValue.length != 3) {
                console.log(newValue);
                // if (table.value.filteredItems && table.value.filteredItems.length < 12) {
                console.log(table.value.filteredItems);
                table.value.filteredItems.forEach(async (part, index) => {
                    if (index < 12 && part.alternative == "") {
                        console.log(index, part);
                        part.alternative = await getAltParts(part)
                        if (part.alternative.startsWith("C")) { part.style = { "background-color": "orange" } }
                        if (part.alternative.startsWith("D1")) { part.style = { "background-color": "lightblue" } }
                        return part
                    }
                    else { return part }

                })

                // }
            }

        })
        watch(PartSearch, (newValue, oldValue) => {
            if (newValue.length == 1 && oldValue == "" || newValue.length == 2 && oldValue.length != 3) {
                console.log(newValue);
                // if (table.value.filteredItems && table.value.filteredItems.length < 12) {
                console.log(table.value.filteredItems);
                table.value.filteredItems.forEach(async (part, index) => {
                    if (index < 12 && part.alternative == "") {
                        console.log(index, part);
                        part.alternative = await getAltParts(part)
                        if (part.alternative.startsWith("C")) { part.style = { "background-color": "orange" } }
                        if (part.alternative.startsWith("D1")) { part.style = { "background-color": "lightblue" } }
                        return part
                    }
                    else { return part }

                })

                // }
            }
        })
        let PartsTable = ref({
            headers: [
                { label: "Supplier", key: "supplierName", align: "center" },
                { label: "ID", key: "partNumber", align: "center" },
                { label: "Part Alternative", key: "alternative", align: "center" },

                { label: "Brand/Family", key: "brand", align: "center" },
                // { label: "P/N", key: "partNumber", align: "center" },
                { label: "Man Code", key: "manufactureCode", align: "center" },
                { label: "Description", key: "description", align: "center" },


                { label: "Add To Cart", key: "cart", align: "center" },

                // { label: " Price ", key: "fullPrice", align: "center" },
                { label: "Price ", key: "unitPrice", align: "center" },
                // { label: "In Stock", key: "inStock", align: "center" },
                // { label: "Special Order", key: "specialOrder", align: "center" },
                // { label: "Obsolete", key: "Obsolete", align: "center" },
                // { label: "Alternative", key: "Alternative", align: "center" },
                { label: "Pos No", key: "positionNumber", align: "center" }
            ],
            items: [],
            selectableRows: true,
            selectionInfo: {},
            loading: false,
            accordion: [false],
            sort: ["+description"],
            height: "",
            filter: (item, index) => {
                const filtered = item.description.toUpperCase().includes(
                    PartSearch.value.toUpperCase()) || item.group.toUpperCase().includes(
                        PartSearch.value.toUpperCase())
                    && item.positionNumber ? item.positionNumber.includes(PosLookup.value.toUpperCase()) : false

                return filtered
            }
        });

        let articleNo = ref({});

        function logFilteredItem() {
            if (table.value.filteredItems && table.value.filteredItems.length < 12) {
                console.log(table.value.filteredItems);
            }
        }

        const partsToGet = useSearchStore().getSearch()
        getALLParts(partsToGet)

        // useSearchStore().setSearch(null)
        const sortByMultipleProperties = (arr, ...properties) => {
            return arr.sort((a, b) => {
                for (let i = 0; i < properties.length; i++) {
                    const [prop, order] = properties[i].split(' ');
                    if (a[prop] > b[prop]) {
                        return order === 'asc' ? 1 : -1;
                    }
                    if (a[prop] < b[prop]) {
                        return order === 'asc' ? -1 : 1;
                    }
                    // If values are equal, compare next criterion
                    continue;
                }
                // If all criteria are equal, return 0
                return 0;
            });
        }
        const sortTable = (arr, properties) => {
            // console.log(properties);
            return arr.sort((a, b) => {
                const [order, prop] = [properties[0].substr(0, 1), properties[0].substr(1)]

                if (a[prop] > b[prop]) {
                    return order == '+' ? 1 : -1;
                }
                if (a[prop] < b[prop]) {
                    return order == '+' ? -1 : 1;
                }
                return 0
            })
        }
        function getALLParts(listOfProducts) {
            console.log("ref", table);
            lastItemOnPage = 11
            PartsTable.value.items = [];
            PartsTable.value.accordion = [true];
            PartsTable.value.loading = true;

            getPartsListFromSupplier(listOfProducts).then(listOfParts => {
                PartsTable.value.items = listOfParts.flatMap(el => [...el.items.flat(1)])
                // console.log(table.value.$el.firstChild.clientHeight);
                files.value = listOfParts.flatMap(el => [...el.files.flat(1)])
                Files.value.items.push(...files.value.map(file => {
                    file.label = file.title
                    return file
                }).sort((a, b) => a.title.localeCompare(b.title)))
                Files.value.items.length > 1 ? Files.value.selection = Files.value.items[1] : null
                PartsTable.value.loading = false
                // console.log(files.value);
                // console.log(PartsTable.sort);

                const itemsPerPage = Math.round(PartsTable.value.items.length / (tableOuterHeight.value.clientHeight / tableInnerHeight.value.clientHeight))
                const altPromise = Promise.all(sortTable(PartsTable.value.items, PartsTable.value.sort != undefined ? PartsTable.value.sort : ["+description"]).map((async (part, index) => {
                    //get size of table - size of whats shown instead of 11 

                    // console.log("Items Per Page", Math.round(tableOuterHeight.value.clientHeight / 80));
                    if (index < 12) {
                        // console.log(index, part);
                        part.alternative = await getAltParts(part)
                        if (part.alternative.startsWith("C")) { part.style = { "background-color": "orange" } }
                        if (part.alternative.startsWith("D1")) { part.style = { "background-color": "lightblue" } }
                        return part
                    }
                    else { return part }

                })))
                altPromise.then(parts => { PartsTable.value.items = parts })
            })

        }
        const rowsPerPage = 10;

        let currentItem = 0;
        let totalPages = 0;
        let pageHeight = 0
        let lastPage = 0
        async function handleScroll(event) {
            // console.log(lastItemOnPage, currentItem);
            const itemsPerPage = Math.round(this.PartsTable.items.length / (event.target.scrollHeight / event.target.clientHeight))
            currentItem = Math.round(event.target.scrollTop / (event.target.scrollHeight / (this.PartsTable.items.length))) + itemsPerPage - 1


            if (currentItem > lastItemOnPage) {
                // console.log("Item from", lastItemOnPage)
                lastItemOnPage = currentItem
                // console.log("Item to", currentItem)
                // console.log("Page", currentItem);
                // console.log("Height", this.tableInnerHeight);
                // console.log(this.PartsTable.sort)
                const lastItemList = sortTable(this.PartsTable.items, this.PartsTable.sort.length > 0 ? this.PartsTable.sort : ["+description"])
                // console.log(lastItemList)
                const part = lastItemList[currentItem]
                const lastItem = part.alternative = await getAltParts(lastItemList[currentItem])
                if (part.alternative.startsWith("C")) { part.style = { "background-color": "orange" } }
                if (part.alternative.startsWith("D1")) { part.style = { "background-color": "lightblue" } }
                // return part
                // console.log(lastItem)
                // lastItem.partNumber = `C000000${currentItem}`
                lastPage = currentItem
            }
            // }

            // if ((event.target.scrollHeight - (event.target.offsetHeight)) <= event.target.scrollTop) {
            //     alert("Bottom");
            // }
        }
        function getPartDetails(part) {
            usePartStore().setPart(part)
            // if (!part.alternative.startsWith("C")) {
            router.push({ name: 'Part', params: { id: part.id } })
            // }
        }
        function addPartToShoppingCart(part) {
            console.log("Item selected", this.PartsTable.selectionInfo)
            useCartStore().addItem(part)

        }
        const blobToBase64 = blob => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            return new Promise(resolve => {
                reader.onloadend = () => {
                    resolve(reader.result);
                };
            });
        };
        const numOfPages = ref(0)
        function openfile(file) {
            // console.log(file);
            if (file.supplierName == "ASWO") {

                getAswoFileFromUrl(file.url).then(async fileData => {
                    // console.log(fileData);
                    if (fileData.type == 'application/pdf') {
                        const pdfSrc = ref(URL.createObjectURL(fileData))
                        const loadingTask = createLoadingTask(pdfSrc.value)
                        loadingTask.promise.then((pdf) => {
                            numOfPages.value = pdf.numPages
                            pdfFile.value.src = pdfSrc.value
                            imageFile.value.src = ""
                        })
                    } else {
                        blobToBase64(fileData).then(img => {
                            imageFile.value.src = img
                        })
                        pdfFile.value.src = ""
                    }
                }
                )

            }
            if (file.supplierName == "Connect") {

                if (file.url.endsWith('.pdf')) {
                    const pdfSrc = ref(file.url)

                    const loadingTask = createLoadingTask(pdfSrc.value)
                    loadingTask.promise.then((pdf) => {
                        numOfPages.value = pdf.numPages
                        pdfFile.value.src = pdfSrc.value
                        imageFile.value.src = ""
                    })

                } else {
                    imageFile.value.src = file.url
                    pdfFile.value.src = ""
                }
            }
            this.dialog.show = true;
        }
        function openFirstFile(file) {

            // console.log(file);
            if (file.supplierName == "ASWO") {

                getAswoFileFromUrl(file.url).then(fileData => {
                    // console.log(fileData);
                    if (fileData.type == 'application/pdf') {
                        const pdfSrc = ref(URL.createObjectURL(fileData))
                        const loadingTask = createLoadingTask(pdfSrc.value)
                        loadingTask.promise.then((pdf) => {
                            numOfPages.value = pdf.numPages
                            pdfFile.value.src = pdfSrc.value
                            imageFile.value.src = ""
                        })
                    } else {
                        // console.log(fileData);
                        blobToBase64(fileData).then(img => {
                            imageFile.value.src = img
                            // console.log(img);
                        })
                        pdfFile.value.src = ""
                    }
                }
                )

            }
            if (file.supplierName == "Connect") {

                if (file.url.endsWith('.pdf')) {
                    const pdfSrc = ref(file.url)
                    const loadingTask = createLoadingTask(pdfSrc.value)
                    loadingTask.promise.then((pdf) => {
                        numOfPages.value = pdf.numPages
                        pdfFile.value.src = pdfSrc.value
                        imageFile.value.src = ""
                    })

                } else {
                    imageFile.value.src = file.url
                    pdfFile.value.src = ""
                }
            }

        }
        return {
            numOfPages,
            supplier: { name: String, code: String },
            getPartDetails,
            getALLParts,
            openFirstFile,
            fileurl,
            pdfFile,
            imageFile,
            SparePartSearch,
            PosLookup,
            PartSearch,
            StockCheck,
            DeliveryTime,
            Obsolete,
            ArticleSearch,
            DeviceArticleSearch,
            DeviceFilesSearch,
            articleNo,
            Files,
            files,
            openfile,
            addPartToShoppingCart,
            name: "Search Aswo",
            props: {
                msg: String
            },
            PartsTable,
            dialog,
            getitemcontrols() {
                return `Artikelnummer`;
            }, handleScroll,
            tableInnerHeight,
            tableOuterHeight,
            table,
            lookingAtModel,
            lookingAtVariant,
            zoomed: false,
            imageAspectRatio: 1,
            // heightChange
        };
    }
};
</script>
 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.w-app .primary--bg {
    background-color: #021d48;
}

div.w-table-wrap {

    height: 65vh;

}

.exploded {
    overflow-y: scroll;
    height: 68.1vh;
    cursor: pointer;
}

div.pdf {
    height: 65vh;
    cursor: pointer;
}

.w-table__cell {
    white-space: nowrap;
}

h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}

img {
    height: 50px;
    width: 50px;
}

.bigImg {
    height: 100%;
    width: 100%;
}

.file {
    /* /* height: 150px; */
    width: 100%;
}
</style>
